<div *ngIf="!invalidRouting">
  <mapfre-alert></mapfre-alert>
</div>
<form
  [formGroup]="newPaymentForm"
  name="newPaymentForm"
  (ngSubmit)="
    newPaymentRadioForm.valid && newPaymentForm.valid && newPaymentFormSubmit()
  " class="new-payment-form"
>
  <section class="row radio-amount" [formGroup]="newPaymentRadioForm">
    <div class="col">
      <h2 class="title margin-bottom mb16 " [ngClass]="{
        'brand-blue-secondary dm-sans-medium mt-2': !isAcmic
      }">
        {{ "SELECT_AMOUNT" | translate }}
      </h2>
      <div class="row radio-container">
        <div class="col mk-col-auto">
          <div class="radio-label">
            <input
              class=""
              type="radio"
              id="paymentAmount-minimum"
              name="paymentAmount"
              formControlName="paymentAmount"
              [value]="currentMinAmtDue"
              [required]="true"
              (change)="
                OnChangeShowCustomAmountField('paymentAmount-minimum');
                setDynamicInputValidation('paymentAmount-minimum')
              "
            />
            <label
              class="no-margin-bottom align-top"
              for="paymentAmount-minimum"
              >{{ "NEXT" | translate }}</label
            >
          </div>
        </div>
        <div class="col-auto pl-0 payment-amount text-right">
          <strong>{{ currentMinAmtDue | currency }}</strong>
        </div>
      </div>
      <div class="row margin-top mt16 radio-container">
        <div class="col mk-col-auto">
          <div class="radio-label">
            <input
              class=""
              type="radio"
              id="paymentAmount-max"
              name="paymentAmount"
              formControlName="paymentAmount"
              [value]="outstandingBalance"
              [required]="true"
              (change)="
                OnChangeShowCustomAmountField('paymentAmount-max');
                setDynamicInputValidation('paymentAmount-max')
              "
            />
            <label class="no-margin-bottom align-top" for="paymentAmount-max">{{
              "OUTSTANDING_BALANCE" | translate
            }}</label>
          </div>
        </div>
        <div class="col-auto pl-0 payment-amount text-right">
          <strong>{{ outstandingBalance | currency }}</strong>
        </div>
      </div>
      <div class="row margin-top mt16 radio-container">
        <div class="col mk-col-auto">
          <div class="radio-label">
            <input
              class=""
              type="radio"
              id="paymentAmount-other"
              name="paymentAmount"
              formControlName="paymentAmount"
              value="other"
              [required]="true"
              (change)="
                OnChangeShowCustomAmountField('other');
                setDynamicInputValidation('other')
              "
            />
            <label
              class="no-margin-bottom align-top"
              for="paymentAmount-other"
              >{{ "OTHER_AMOUNT" | translate }}</label
            >
          </div>
        </div>
      </div>
      <div class="row margin-top mt32 other-amount" *ngIf="showCustomAmount">
        <div class="col input-content margin-left ml32">
          <div class="input-field mapfre">
            <input
              class="w-50"
              formControlName="otherAmount"
              id="otherAmount"
              name="otherAmount"
              type="number"
              required="true"
              (keyup)="checkAmountNow($event)"
              (focus)="enterAmount($event)"
              (focusout)="enterAmount($event)"
            />
            <mapfre-label
              forInput="otherAmount"
              [validationCSSClass]="enterAmountlabel"
              >{{ "ENTER_AMOUNT" | translate }}</mapfre-label
            >
          </div>
          <div
            class="help-block error-block"
            *ngIf="
              newPaymentRadioForm.controls.otherAmount.errors?.pattern
                ?.actualValue;
              else minOrMax
            "
          >
            {{ "NOT_IN_A_VALID_FORMAT" | translate }}
          </div>
          <ng-template #minOrMax>
            <div
              class="help-block error-block"
              *ngIf="newPaymentRadioForm.controls.otherAmount.errors?.min?.min"
            >
              {{ "THIS_AMOUNT_IS_GREATER_THAN_ONE" | translate }}
            </div>
            <div
              class="help-block error-block"
              *ngIf="newPaymentRadioForm.controls.otherAmount.errors?.max?.max"
            >
              {{ "THIS_AMOUNT_IS_GREATER_THAN_OUTSTANDING" | translate }}
              {{ billingDetails?.outstandingbalance | currency }}
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </section>
  <section class="row bank-inputs margin-top mt24">
    <div class="col">
      <ng-container *ngIf="isAcmic; else MAStateNewPaymentMK">
        <h2 class="title new-payment">
          {{ "CHECKING_ACCOUNT" | translate }}
          <ng-container *ngIf="storeBankAccount?.accountHolderName">
            <mapfre-button
              additionalClasses="link-button blue-link float-right no-border text-capitalize no-padding edit-account-button"
              (click)="OnClickEditButton()"
            >
              <span>{{ "EDIT" | translate }}</span>
              <img src="assets/img/images/icon-edit-acmic-24.svg" class="" alt="edit icon" />
            </mapfre-button>
          </ng-container>
        </h2>
      </ng-container>
      <ng-template #MAStateNewPaymentMK>
        <h2 class="title new-payment dm-sans-medium mb-3">
          {{ "CHECKING_ACCOUNT" | translate }}
          <ng-container *ngIf="storeBankAccount?.accountHolderName">
            <mapfre-button
              additionalClasses="link-button red-link float-right no-border no-padding edit-account-button"
              (click)="OnClickEditButton()"
            >
              <span>{{ "EDIT" | translate }}</span>
              <img src="./assets/img/images/icon-edit-red.svg" alt="edit icon" width="24" height="24" />
            </mapfre-button>
          </ng-container>
        </h2>
      </ng-template>

      <ng-container *ngIf="!loading">
        <ng-container
          *ngIf="editAccount || !storeBankAccount?.accountHolderName"
        >
          <div class="checking-form newPaymentFields margin-top mt16">
            <div>
                                <p class="account-type-radio-heading">Account type</p>
                        <mapfre-validation
                            [input]="accountTypeInput"
                            [form]="newPaymentRadioForm">
                        </mapfre-validation>
                    </div>
            <div
              *ngFor="let input of inputs | slice: 0:4; index as i"
              class="input"
            >
              <mapfre-validation
                [input]="input"
                [form]="newPaymentForm"
                [maximumLength]="9"
              ></mapfre-validation>
            </div>
            <div class="address-container">
              <div
                class="d-flex capsule_toggles"
                *ngIf="policyId.length !== 10"
              >
                <mapfre-button
                  [ngClass]="{
                    active: isMailingAddSelected,
                    'add-toggle-btn': true
                  }"
                  additionalClasses="basic large-btn mail-address-border"
                  [inputType]="'button'"
                  (click)="selectAddressType('mailing-address')"
                >
                  {{ "MAILING_ADDRESS" | translate }}
                </mapfre-button>
                <mapfre-button
                  [ngClass]="{
                    active: isPOBoxAddSelected,
                    'add-toggle-btn': true
                  }"
                  additionalClasses="basic large-btn po-box-border"
                  [inputType]="'button'"
                  (click)="selectAddressType('poBox-address')"
                >
                  {{ "PO_BOX_ADDRESS" | translate }}
                </mapfre-button>
              </div>
              <div class="address-section">
                <div
                  *ngFor="let input of inputs | slice: 4; index as i"
                  class="input"
                  [ngClass]="{
                    'first-input': input?.key === 'newPayment_mailingAddress',
                    'second-input MA_AppSuite':
                      input?.key === 'newPayment_aptNumber',
                    MAZipCode:
                      input?.key === 'newPayment_zipCode' ||
                      input?.key === 'newPayment_PO_zipCode',
                    MACityState:
                      input?.key === 'newPayment_city_state' ||
                      input?.key === 'newPayment_PO_city_state',
                    MACitySelect:
                      input?.key === 'newPayment_multipleCities' ||
                      input?.key === 'newPayment_PO_multipleCities',
                    MAState:
                      input?.key === 'newPayment_state' ||
                      input?.key === 'newPayment_PO_state',
                    MASelectedState:
                      isMailingAddSelected &&
                      (input?.key === 'newPayment_state' ||
                        input?.key === 'newPayment_PO_state'),
                    storeCheckBox: input?.key === 'newPayment_storeInformation',
                    npchecknumber: input?.key === 'newPayment_checkNumber',
                    hide:
                      (input.key === 'newPayment_city_state' &&
                        hideCityStateField) ||
                      (input?.key === 'newPayment_mailingAddress' && 
                        isPOBoxAddSelected) ||  
                      (input.key === 'newPayment_PO_city_state' &&
                        hidePoBoxCityStateField) ||
                      (input.key === 'newPayment_zipCode' &&
                        isMailingAddSelected &&
                        hideZipcodeField),
                    hides:
                      ((input.key === 'newPayment_multipleCities' ||
                        input.key === 'newPayment_state') &&
                        (isPOBoxAddSelected || hideMultipleCityStateField)) ||
                      ((input.key === 'newPayment_PO_multipleCities' ||
                        input.key === 'newPayment_PO_state') &&
                        (isMailingAddSelected || hidePOMultipleCityStateField))
                  }"
                >
                  <ng-container
                    *ngIf="
                      input.inputType === 'checkbox' && isEFT !== 'ENROLLED'
                    "
                  >
                    <div
                      class="margin-top mt8 margin-bottom mb16 default-checkbox-label safariFixLbl"
                    >
                      <input
                        type="checkbox"
                        class="single-checkbox"
                        id="store-checkbox"
                        (change)="getStoreAccountInfo($event)"
                      />
                      <label
                        class="margin-left ml16 no-margin-bottom"
                        for="store-checkbox"
                        [ngClass]="{'ml24':!isAcmic}"
                        >{{ input.label | translate }}</label
                      >
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      input.inputType !== 'checkbox' &&
                      input.inputType !== 'select' &&
                      !(input?.key === 'newPayment_checkNumber' &&
                        newPaymentRadioForm.controls['accountType'].value === 'SAVINGL')
                    "
                  >
                    <mapfre-validation
                      [input]="input"
                      [form]="newPaymentForm"
                      [maximumLength]="9"
                      (addressinputValidationCheck)="isValidMailingAdd($event)"
                      [ngClass]="{
                        hide:
                          ((input.key === 'newPayment_mailingAddress' ||
                            input?.key === 'newPayment_zipCode' ||
                            input?.key === 'newPayment_city_state') &&
                            (policyId.length === 10 || isPOBoxAddSelected)) ||
                          ((input.key === 'newPayment_poBoxAddress' ||
                            input?.key === 'newPayment_PO_zipCode' ||
                            input?.key === 'newPayment_PO_city_state') &&
                            isMailingAddSelected),
                        hides:
                          input.key === 'newPayment_aptNumber' &&
                          (policyId.length === 10 || isPOBoxAddSelected)
                      }"
                    >
                    </mapfre-validation>
                    <label
                      class="custom_label check_custom"
                      *ngIf="
                        input?.key === 'newPayment_mailingAddress' &&
                        !changeAddressError
                      "
                      [ngClass]="{
                        hide:
                          input.key === 'newPayment_mailingAddress' &&
                          (policyId.length === 10 || isPOBoxAddSelected)
                      }"
                      >{{ "NUMBER_AND_STREET" | translate }}
                    </label>
                    <label
                      class="custom_label check_custom"
                      *ngIf="input?.key === 'newPayment_aptNumber'"
                      [ngClass]="{
                        hide: policyId.length === 10 || isPOBoxAddSelected
                      }"
                      >{{ "OPTIONAL" | translate }}
                    </label>
                  </ng-container>
                  <ng-container *ngIf="input.inputType === 'select'">
                    <label class="custom_city_label">{{
                      "City" | translate
                    }}</label>
                    <select
                      [id]="input.key"
                      [formControlName]="input.key"
                      class="custom-select custom-select-font mb8"
                      (change)="onCityChange($event)"
                    >
                      <ng-container *ngIf="isMailingAddSelected">
                        <option
                          *ngFor="
                            let opt of multipleCityOptionsForMailing;
                            index as index
                          "
                          [value]="opt"
                        >
                          {{ opt }}
                        </option>
                      </ng-container>
                      <ng-container *ngIf="isPOBoxAddSelected">
                        <option
                          *ngFor="
                            let opt of multipleCityOptionsForPOBox;
                            index as index
                          "
                          [value]="opt"
                        >
                          {{ opt }}
                        </option>
                      </ng-container>
                    </select>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container
          *ngIf="storeBankAccount?.accountHolderName && !editAccount"
        >
          <div class="checking-info margin-top mt24">
            <div class="row  margin-bottom mb8">
              <div class="col">
                {{ "ACCOUNT_HOLDER" | translate }}:<span
                  class="uppercase margin-left ml16"
                  >
                  <strong>{{
                    storeBankAccount?.accountHolderName.toUpperCase()
                  }}</strong></span
                >
              </div>
            </div>
            <div class="row margin-bottom mb24">
              <div class="col">
                {{ "ACCOUNT_NUMBER" | translate }}:<span
                  class="margin-left ml16"
                  ><strong >{{
                    storeBankAccount?.accountNumber.digits | maskAccountNumber
                  }}</strong></span
                >
              </div>
            </div>
          </div>
          <div class="row" [formGroup]="newPaymentForm">
            <ng-container *ngFor="let input of inputs">
              <div
                class="col input-content"
                *ngIf="
                  input?.key === 'newPayment_checkNumber' &&
                  newPaymentRadioForm.controls['accountType'].value !== 'SAVINGL'
                "
              >
                <mapfre-validation [input]="input" [form]="newPaymentForm">
                </mapfre-validation>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <div
          class="row justify-content-center pl-3 row-btn-continue margin-top mt24"
        >
          <div *ngIf="showCustomAmount; else showAmount">
            <mapfre-button
              [ngClass]="{ custom_loader: loader }"
              additionalClasses="basic primary large-btn no-margin"
              [disabledValue]="
                newPaymentRadioForm.valid &&
                newPaymentForm.valid &&
                checkAmount &&
                !loader &&
                (isMailingAddSelected ? isMailingAddressValid : true) &&
                (isMailingAddSelected ? isZipcodeValid : isPoBoxZipcodeValid)
              "
              [inputType]="'submit'"
              [translateValue]="'CONTINUE' | translate"
            >
            </mapfre-button>
          </div>
          <ng-template #showAmount>
            <div>
              <mapfre-button
                [ngClass]="{ custom_loader: loader }"
                additionalClasses="basic primary large-btn no-margin"
                [disabledValue]="
                  newPaymentRadioForm.valid &&
                  newPaymentForm.valid &&
                  !loader &&
                  (isMailingAddSelected ? isMailingAddressValid : true) &&
                  (isMailingAddSelected ? isZipcodeValid : isPoBoxZipcodeValid)
                "
                [inputType]="'submit'"
                [translateValue]="'CONTINUE' | translate"
              >
              </mapfre-button>
            </div>
          </ng-template>
        </div>
        <div
          class="row justify-content-center pl-3 row-btn-cancel margin-vertical mv24"
        >
          <div class="btn-margin-mobile">
            <mapfre-button
              additionalClasses="ghost secondary no-margin {{isAcmic ? 'medium-btn' : 'large-btn  ach-new-pay-btn'}}"
              *ngIf="achPay; else achLinkRef"
              (click)="goBack()"
              >
              {{ "CANCEL" | translate }}
            </mapfre-button>
            <ng-template #achLinkRef>
              <mapfre-button
                additionalClasses="ghost secondary medium-btn no-margin"
                [routerLink]="['/my-insurance', policyId, 'billing']"
              >
                {{ "CANCEL" | translate }}
              </mapfre-button>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </div>
  </section>
</form>
